var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_vm._l((_vm.formattedSources),function(source){return _c('source',{key:source.width,attrs:{"media":("(max-width: " + (source.width) + "px)"),"srcset":source.src}})}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }